@if (this.progress(); as progress) {
  <progress
    [attr.max]="progress.total"
    [attr.value]="progress.played"
    title="{{ progress.played }} of {{ progress.total }} games played"
  >
    {{ progress.played }} /
    {{ progress.total }}
  </progress>
}

<dl>
  @for (attr of attributes(); track attr.label) {
    <div>
      <dt>{{ attr.label }}</dt>
      <dd>{{ attr.value }}</dd>
    </div>
  }

  @if (this.winner(); as winner) {
    <div class="podium">
      <dt>
        <span>Winner</span>
      </dt>
      <dd>
        <lib-player
          rosette="🏆"
          avatarSize="sm"
          [player]="winner"
          [linkEnabled]="false"
        />
      </dd>
    </div>
  }
  @if (this.runnerUp(); as runnerUp) {
    <div class="podium">
      <dt>Runner-up</dt>
      <dd>
        <lib-player rosette="🥈" [player]="runnerUp" [linkEnabled]="false" />
      </dd>
    </div>
  }
</dl>
